import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ChangeControlConstants } from '../constants/changeControlConstants';
import { ActionItemDetails } from '../models/action-item-details';

@Injectable({
  providedIn: 'root'
})
export class ChangeControlPersistenceService {

  previousPhaseButtonDisable$ = new BehaviorSubject<boolean>(false);
  previousPhaseButtonToolTip$ = new BehaviorSubject<string>(ChangeControlConstants.ChangeControl_PreviousPhase_ToolTip);
  selectedActionitem$ = new BehaviorSubject<ActionItemDetails[]>([]);
  selectedScopes = new Subject<number[]>();
  actionPlanDataUpdated = new Subject<boolean>();
  isChangeControlUpdated$ = new Subject<boolean>();
  acValidatedUsersList:any=[];
  currentPhaseOfChangeControl:any;

  constructor() { }

  updatePreviousPhaseButtonVisibility = (data: boolean) => {
    this.previousPhaseButtonDisable$.next(data);
  }

  updatePreviousPhaseToolTip =(data: string) => {
    this.previousPhaseButtonToolTip$.next(data);
  }

  updateSelectedActionitem = (data : ActionItemDetails[]) => {
    this.selectedActionitem$.next(data);
  }

  updateInActionPlanData() : Observable<boolean> {
    return this.actionPlanDataUpdated.asObservable();
  }
  updateChangeControlView = () => {
   this.isChangeControlUpdated$.next(true);
  }

  updateScopesOnChangeControlUpdate() : Observable<number[]> {
    return this.selectedScopes.asObservable();
  }
}
